"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeApollo = exports.createApolloClient = exports.X_DEBUG_FLAG_KEY = void 0;
const client_1 = require("@apollo/client");
const deepmerge_1 = __importDefault(require("deepmerge"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const config_1 = __importDefault(require("next/config"));
const authLinks_1 = require("./extensions/authLinks");
const errorLink_1 = require("./extensions/errorLink");
const previewLink_1 = require("./extensions/previewLink");
const versionLink_1 = require("./extensions/versionLink");
const { serverRuntimeConfig = {}, publicRuntimeConfig = {} } = (0, config_1.default)();
const { graphqlServerUri: graphqlUri = publicRuntimeConfig.graphqlUri, fdrGraphqlServerUri: fdrGraphqlUri = publicRuntimeConfig.fdrGraphqlUri, } = serverRuntimeConfig;
let apolloClient;
const FDR_FLAG_KEY = 'x-api-version';
const FDR_FLAG_VALUE = 'federation';
exports.X_DEBUG_FLAG_KEY = 'X-Debug-Subgraph';
function createApolloClient(config = {}) {
    const { getXDebugSubgraph, getAccessToken, getPreview, possibleTypes, typePolicies, } = config;
    if (process.env.NODE_ENV !== 'production') {
        if (!getAccessToken) {
            // eslint-disable-next-line no-console
            console.warn(`getAccessToken is not configured, queries authentication could not be proceed.`);
        }
    }
    return new client_1.ApolloClient({
        connectToDevTools: process.env.NODE_ENV !== 'production',
        ssrMode: typeof window === 'undefined',
        link: (0, client_1.from)([
            (0, authLinks_1.authenticationLink)(getAccessToken),
            authLinks_1.retryLink,
            versionLink_1.versionLink,
            (0, previewLink_1.previewLink)(getPreview),
            errorLink_1.errorLink,
            new client_1.HttpLink({
                uri: graphqlUri,
                credentials: `same-origin`, // Additional fetch() options like `credentials` or `headers`
                fetch(uri, options) {
                    const url = options.headers[FDR_FLAG_KEY] === FDR_FLAG_VALUE
                        ? fdrGraphqlUri
                        : uri;
                    if (getXDebugSubgraph && typeof getXDebugSubgraph === 'function') {
                        const xDebugHeader = getXDebugSubgraph();
                        if (xDebugHeader)
                            options.headers[exports.X_DEBUG_FLAG_KEY] = xDebugHeader;
                    }
                    return fetch(url, options);
                },
            }),
        ]),
        cache: new client_1.InMemoryCache({
            addTypename: true,
            possibleTypes,
            typePolicies: typePolicies,
        }),
    });
}
exports.createApolloClient = createApolloClient;
function initializeApollo(initialState = null, config) {
    const apolloClientObject = apolloClient !== null && apolloClient !== void 0 ? apolloClient : createApolloClient(config);
    // If your page has Next.js data fetching methods that use Apollo Client, the initial state
    // gets hydrated here
    if (initialState) {
        // Get existing cache, loaded during client side data fetching
        const existingCache = apolloClientObject.extract();
        // Merge the existing cache into data passed from getStaticProps/getServerSideProps
        const data = (0, deepmerge_1.default)(existingCache, initialState, {
            // combine arrays using object equality (like in sets)
            arrayMerge: (destinationArray, sourceArray) => [
                ...sourceArray,
                ...destinationArray.filter(d => sourceArray.every(s => !(0, isEqual_1.default)(d, s))),
            ],
        });
        // Restore the cache with the merged data
        apolloClientObject.cache.restore(data);
    }
    // For SSG and SSR always create a new Apollo Client
    if (typeof window === 'undefined')
        return apolloClientObject;
    // Create the Apollo Client once in the client
    if (!apolloClient)
        apolloClient = apolloClientObject;
    return apolloClientObject;
}
exports.initializeApollo = initializeApollo;
//# sourceMappingURL=apolloClient.js.map